import { TypedBackendError } from '../types/types';
import { exhaustiveCheck } from '@tradgine/utils';
import { formatValidationError } from '../formatters/format-validation-error';
import { formatListValidationError } from '../formatters/format-list-validation-error';
import { formatAggregatedError } from '../formatters/format-aggregated-error';
import { formatServerError } from '../formatters/format-server-error';

export function mapBackendErrorToMessage(error: TypedBackendError): string {
    switch (error.type) {
        case 'Validation':
            return formatValidationError(error);

        case 'Extendable':
        case 'Default':
            return error.title;

        case 'ListValidation':
            return formatListValidationError(error);

        case 'Aggregated':
            return formatAggregatedError(error);

        case 'ServerError':
            return formatServerError(error);

        default:
            return exhaustiveCheck(error);
    }
}
